<template>
  <div class="mains">
    <div class="tiyouimg">
      <img style="width: 100%;max-width: 100%;height: auto;max-height: 100%" src="../assets/img/about/about1.png"/>
        <a target="_blank" href="https://diamondyu.com"></a>
    </div>
<!--    <div style="width: 100%;margin-top: 80px;display: flex;align-items: center">-->
<!--      <div style="position: absolute;margin-left: 50%;font-size: 18px;margin-right: 3%;-->
<!--        -->
<!--        font-weight: 400;-->
<!--        color: #808080;-->
<!--        ">-->
<!--        红亚教育科技（上海）有限公司（“红亚教育科技”）是聚焦教育科技及公安行业需求，专注大数据挖掘、AI识别、虚拟仿真、区块链、人工智能等信息技术，提供优质技术服务的创新型科技公司。 红亚教育科技核心研发团队来自清华大学，是国内物联网、人工智能领域领先的研究团队，科研成果覆盖AI智能视觉，物联网泛在感知，职业能力画像模型，虚拟仿真，多摄像头融合动捕，大数据挖掘等前沿领域。 红亚教育科技（上海）有限公司是上海市高新技术企业、软件企业及第二批产教融合型企业。-->
<!--      </div>-->
<!--      <img style="width: 100%;max-width: 100%;height: auto;max-height: 100%" src="../assets/img/about/about8.png"/>-->
<!--    </div>-->
    <div style="width: 70%;height: 100%;display: flex;flex-direction: column;align-items: center;margin: 56px 15%">
      <div style="font-size: 32px;

      font-weight: bold;
      color: #3A3A3A;
      line-height: 18px;"
      >
        公司资质
      </div>
      <div style="font-size: 18px;

        font-weight: 400;
        color: #6A6A6A;
        line-height: 31px;
        margin-top: 20px">
        拥有多项权威技术资质认证，你们的信任就是对我们最大的支持
      </div>
      <div style="width: 100%;height: 100%;margin-top: 47px;display: flex;justify-content: center">
        <div style="width: 100%;height: auto;padding: 0 30px;position: relative">
          <div class="swiper-container" ref="swp" @mouseenter="on_enter" @mouseleave="on_leave">
            <div class="swiper-wrapper">
              <div
                  class="swiper-slide lunbopic"
                  :list="list"
                  v-for="item in list"
                  :key="item.id"
              >
                <img class="swiper-slide lunbopic"
                     :list="list"
                     v-for="item in list"
                     :key="item.id" :src="item.src" alt="" />
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <!--          <div class="swiper-pagination"></div>-->
            <!-- 如果需要滚动条 -->
            <!--    <div class="swiper-scrollbar"></div>-->
          </div>

          <!-- 如果需要导航按钮 -->
          <div title="减速" class="swiper-button-prev" @click="speed(1)"></div>
          <div title="加速" class="swiper-button-next" @click="speed(2)"></div>
        </div>
      </div>
    </div>

    <div style="width: 70%;height: 100%;display: flex;flex-direction: column;align-items: center;margin: 56px 15%">
      <div style="font-size: 32px;

      font-weight: bold;
      color: #3A3A3A;
      line-height: 18px;"
      >
        合作院校
      </div>
      <div style="width: 100%;height: 100%;margin-top: 47px;display: flex;justify-content: center">
        <img style="width: 100%" src="../assets/img/about/about5.png" alt="">
      </div>
      <div style="margin-top: 27px;width: 100%;height: auto;display: flex;justify-content: flex-end">
        <img style="height: 17px;width: 68px" src="../assets/img/about/about7.png" alt="">
      </div>
    </div>

  </div>
</template>
<script>
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper'
export default {
  name: "About",
  components: {
    Swiper
  },
  data(){
    return{
      list:[
      ],
      myswiper:{},
      speeds:4000,
    }
  },
  created() {
    this.initpic()
  },
  mounted() {
    /* eslint-disable no-new */
    setTimeout(()=>{
      this.swiper()//防止第一张图闪过
    },500)
  },
  computed: {
    mySwiper() {
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.swp.swiper
    },
  },
  methods: {
    swiper(){
       this.myswiper =  new Swiper('.swiper-container', {
        slidesPerView: 5,
        spaceBetween : 10,
        loop: true,
// 如果需要分页器
        pagination: '.swiper-pagination',
// 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        // scrollbar: '.swiper-scrollbar',
        // 如果需要自动切换海报
        speed:this.speeds,
        autoplay: {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        autoplayDisableOnInteraction: false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
      })
    },
    on_enter(){
      this.mySwiper.stopAutoplay();
    },
    on_leave () {
      this.mySwiper.startAutoplay();
    },

    //初始化图片
    initpic(){
      for (let i = 1; i < 19; i++) {
        this.list.push({id:i,src:require("../assets/img/about/ryzs/ryzs"+i+".jpg")})
      }
    },
    speed(val){
      if(val == 1){
        this.myswiper.params.speed+=1000;
        this.$message.success("已减速！")
      }else{
        if(this.myswiper.params.speed >1000){
          this.myswiper.params.speed-=1000;
          this.$message.success("已加速！")
        }
        else{
          this.$message.warning("速度过快！")
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.mains{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  flex-direction: column;
  display: flex;
  .tiyouimg{
    width: 100%;
      position: relative;
      a{
         width: 200px;
          height: 30px;
          position: absolute;
          top: 58%;
          left: 11%;
      }
  }
}
img{
  width: 100%;
  height: auto;
  max-height: 100%;
  max-width: 100%;
}

.lunbopic{
  display: flex;
  align-items: center;
  //height: 342px;
  img{
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.swiper-container{
  position: relative;
  width: 100%;
  height: 100%;
}

/*去掉默认样式*/
.swiper-button-prev:after{
  display: none;
}
.swiper-button-next:after{
  display: none;
}
/*自定义样式*/
.swiper-button-prev{
  position: absolute;
  background-color: #fff;
  width: 51px;
  height: 51px;
  border-radius: 50%;
  font-size: 16px;
  background-size: 30% 30%;/*按比例缩放*/
  top: 50%;
  left: 0.8%;
  box-shadow: 0 0 10px #888888;
}

.swiper-button-next{
  position: absolute;
  background-color: #fff;
  width: 51px;
  height: 51px;
  border-radius: 50%;
  background-size: 30% 30%;/*按比例缩放*/
  top: 50%;
  right: 0.8%;
  box-shadow: 0 0 10px #888888;
}
.swiper-container .swiper-wrapper{
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
</style>
